import {
  can,
  PermissionFlags,
  THREAD_CHANNEL_TYPES,
} from '@alternativamais/chat-core';
import { useState } from 'react';

import { avisarErro } from '../../../componentes/Avisos';
import { Icone } from '../../../componentes/Icone';
import { useCliente, useEstado } from '../../../chat/contexto';

/**
 * Thread arquivada (C45): o aviso acima do compositor. Mandar mensagem
 * reabre (como no Discord); "Desarquivar" para quem gerencia ou criou.
 */
export function FaixaArquivada({ threadId }: { threadId: string }) {
  const cliente = useCliente();
  const thread = useEstado((estado) => estado.channels[threadId]);
  const euId = useEstado((estado) => estado.me?.id);
  const gerencia = useEstado((estado) =>
    can(estado, threadId, PermissionFlags.MANAGE_THREADS),
  );
  const [enviando, setEnviando] = useState(false);
  if (!thread || !THREAD_CHANNEL_TYPES.has(thread.type)) return null;
  const meta = thread.thread_metadata;
  if (!meta?.archived) return null;
  const pode = gerencia || (thread.owner_id === euId && !meta.locked);
  return (
    <div className="shrink-0 px-4 pb-2">
      <div
        role="status"
        className="flex min-h-14 items-center gap-2.5 rounded-[10px] border border-borda bg-lateral py-2.5 pr-2 pl-3.5"
      >
        <Icone
          nome="caixa-entrada"
          tamanho={20}
          className="shrink-0 text-texto-3"
        />
        <p className="m-0 min-w-0 grow text-sm text-texto-2">
          <strong className="font-semibold text-texto">
            Esta thread está arquivada.
          </strong>{' '}
          {meta.locked
            ? 'Está trancada: só quem gerencia threads reabre.'
            : 'Mandar uma mensagem a reabre.'}
        </p>
        {pode && (
          <button
            type="button"
            disabled={enviando}
            onClick={() => {
              setEnviando(true);
              cliente.api
                .modifyChannel(threadId, { archived: false })
                .then((canal) => cliente.store.getState().upsertChannel(canal))
                .catch(avisarErro)
                .finally(() => setEnviando(false));
            }}
            className="h-8 shrink-0 rounded-lg bg-ativo px-3 text-[13px] font-semibold text-texto hover:brightness-110"
          >
            Desarquivar
          </button>
        )}
      </div>
    </div>
  );
}
